var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chart-period-selector',{attrs:{"compact":"","value":_vm.period,"periods":_vm.periods},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }